import React from 'react';

import AddOnsStore from '~store/AddOnsStore';
import UserAdminStore from '~store/AdminStores/UserAdminStore';
import AuthStore from '~store/AuthStore';
import CompanyAssetsStore from '~store/CompanyAssetsStore';
import DriverSchedulerStore from '~store/DriverSchedulerStore';
import GeneralStore from '~store/GeneralStore';
import InvoiceLineItemsStore from '~store/InvoiceLineItemsStore';
import InvoicesStore from '~store/InvoicesStore';
import JobStore from '~store/JobStore';
import LiveMapStore from '~store/LiveMapStore';
import MessagingConnectionStore from '~store/MessagingConnectionStore';
import MessagingOpenConversationStore from '~store/MessagingOpenConversationStore';
import OrdersStore from '~store/OrdersStore';
import ProjectsStore from '~store/ProjectsStore';
import SettlementLineItemsStore from '~store/SettlementLineItemsStore';
import SettlementsStore from '~store/SettlementsStore';
import TicketsStore from '~store/TicketsStore';
import ToasterStore from '~store/ToasterStore';
import TreadAgentStore from '~store/TreadAgentStore';
import UserStore from '~store/UserStore';

import ApproveJobsStore from './ApproveJobsStore';
import BulkAssignMultipleStore from './BulkAssignMultipleStore';
import DriverDayStore from './DriverDayStore';
import LiveMapStoreNew from './LiveMapStoreNew';
import OrdersAssignedStore from './OrdersAssignedStore';
import OrdersDispatchStore from './OrdersDispatchStore';
import RutterIntegrationStore from './RutterIntegrationStore';

export class RootStore {
  public addOnsStore: AddOnsStore;
  public authStore: AuthStore;
  public bulkAssignMultipleStore: BulkAssignMultipleStore;
  public companyAssetsStore: CompanyAssetsStore;
  public driverDayStore: DriverDayStore;
  public driverSchedulerStore: DriverSchedulerStore;
  public generalStore: GeneralStore;
  public invoiceLineItemsStore: InvoiceLineItemsStore;
  public invoicesStore: InvoicesStore;
  public jobStore: JobStore;
  public liveMapStore: LiveMapStore;
  public liveMapStoreNew: LiveMapStoreNew;
  public messagingConnectionStore: MessagingConnectionStore;
  public messagingOpenConversationStore: MessagingOpenConversationStore;
  public ordersDispatchStore: OrdersDispatchStore;
  public ordersStore: OrdersStore;
  public ordersAssignedStore: OrdersAssignedStore;
  public projectsStore: ProjectsStore;
  public settlementLineItemsStore: SettlementLineItemsStore;
  public settlementsStore: SettlementsStore;
  public ticketsStore: TicketsStore;
  public toasterStore: ToasterStore;
  public treadAgentStore: TreadAgentStore;
  public userAdminStore: UserAdminStore;
  public userStore: UserStore;
  public rutterIntegrationStore: RutterIntegrationStore;
  public approveJobsStore: ApproveJobsStore;
  constructor() {
    this.addOnsStore = new AddOnsStore();
    this.authStore = new AuthStore(this);
    this.bulkAssignMultipleStore = new BulkAssignMultipleStore();
    this.companyAssetsStore = new CompanyAssetsStore(this);
    this.driverDayStore = new DriverDayStore();
    this.driverSchedulerStore = new DriverSchedulerStore();
    this.generalStore = new GeneralStore(this);
    this.invoiceLineItemsStore = new InvoiceLineItemsStore();
    this.invoicesStore = new InvoicesStore();
    this.jobStore = new JobStore(this);
    this.liveMapStore = new LiveMapStore(this);
    this.liveMapStoreNew = new LiveMapStoreNew();
    this.messagingConnectionStore = new MessagingConnectionStore();
    this.messagingOpenConversationStore = new MessagingOpenConversationStore();
    this.ordersDispatchStore = new OrdersDispatchStore();
    this.ordersStore = new OrdersStore(this);
    this.ordersAssignedStore = new OrdersAssignedStore();
    this.projectsStore = new ProjectsStore(this);
    this.settlementLineItemsStore = new SettlementLineItemsStore();
    this.settlementsStore = new SettlementsStore();
    this.ticketsStore = new TicketsStore(this);
    this.toasterStore = new ToasterStore(this);
    this.treadAgentStore = new TreadAgentStore();
    this.userAdminStore = new UserAdminStore(this);
    this.userStore = new UserStore(this);
    this.rutterIntegrationStore = new RutterIntegrationStore();
    this.approveJobsStore = new ApproveJobsStore();
  }
}

export const rootStore = new RootStore();
const StoresContext = React.createContext(rootStore);

// This will be the function available for the app to connect to the stores
export const useStores = () => React.useContext(StoresContext);
